export interface PublicApiFormState {
  name: string;
  timeToLive: string;
}

export interface IPublicApiResponse {
  clientId: string;
  name: string;
  timeToLive: string;
  updatedOn: string;
}

export const publicApiParser = {
  fromJson: (json: any) => {
    return {
      clientId: json['clientId'] ?? '',
      name: json['name'] ?? '',
      timeToLive: json['timeToLive'] ?? '',
      updatedOn: json['updatedOn'] ?? '',
    }
  }
}
